import React from 'react';

const ClosingPage = () => {
  return (
    <div className="h-screen flex items-center justify-center bg-brand">
      <div className="text-white text-center p-8">
        <h1 className="text-4xl font-bold mb-4">Thank you for signing up!</h1>
        <p className="text-xl mb-8">We look forward to seeing you soon.</p>
        
        <div className="bg-white text-brand px-6 py-3 rounded-full">
          <span>You may now close this tab</span>
        </div>
        
        <p className="text-sm mt-4">It will reopen when you click the Signup verification email we sent to you.</p>
      </div>
    </div>
  );
};

export default ClosingPage;